(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/dialog/assets/javascripts/areas/accessibility.js') >= 0) return;  svs.modules.push('/components/components/dialog/assets/javascripts/areas/accessibility.js'); 'use strict';

svs = svs || {};
svs.components = svs.components || {};
svs.components.dialog = svs.components.dialog || {};

class Accessibility {
  constructor(options) {
    this.log = new svs.core.log.Logger('DialogAccessibility');
    this.el = options.el;
    this.type = options.type;
    this.attachTo = options.attachTo;
    this.activeElBeforeOpen = options.activeElBeforeOpen ? options.activeElBeforeOpen : document.body;

    if (this.type === svs.components.dialog.area.POPUP) {
      this.initPopup();
    }

    if (this.type === svs.components.dialog.area.TOASTER) {
      this.initToaster();
    }
  }

  initPopup() {
    this.focusCatcher = document.createElement('div');
    this.focusCatcher.setAttribute('tabindex', '0');
    this.attachTo.appendChild(this.focusCatcher);
    this.focusCatcher.addEventListener('focus', () => {
      this.log.debug('User tries to tab out of dialog - Let us move them back to the top.');
      this.el.focus();
    });
    this.keyListenerId = svs.utils.keylistener.addKeyboardListener(event => {
      this.keyEventsListenerPopup(event);
    });
  } 


  keyEventsListenerPopup(e) {
    if (e.shiftKey && e.code === 'Tab' && this.el === document.activeElement) {
      this.log.debug('User tries to tab backwards out of dialog - let us move them to the last button in dialog.');
      e.preventDefault();
      const buttons = this.el.querySelectorAll('.js-dialog-item')[0].querySelectorAll('.dialog-button');
      const buttonsLength = buttons.length; 

      if (buttons[buttonsLength - 1].getAttribute('tabindex') === '-1') {
        buttons[buttonsLength - 2].focus();
      } else {
        buttons[buttonsLength - 1].focus();
      }
    } 


    if (e.keyCode && e.keyCode === 27 || e.key && e.key.toLowerCase() === 'esc' || e.key && e.key.toLowerCase() === 'escape') {
      this.triggerClick(document.querySelector('.dialog-button-secondary'));
    }
  }

  initToaster() {
    this.keyListenerId = svs.utils.keylistener.addKeyboardListener(event => {
      this.keyEventsListenerToaster(event);
    });
  } 


  keyEventsListenerToaster(e) {
    if (e.shiftKey && e.key && e.key.toLowerCase() === 'tab' && this.el === document.activeElement) {
      e.preventDefault();
      this.activeElBeforeOpen.focus();
    } 


    if (!e.shiftKey && e.key && e.key.toLowerCase() === 'tab' && this.el.querySelectorAll('.dialog-button')[this.el.querySelectorAll('.dialog-button').length - 1] === document.activeElement) {
      e.preventDefault();
      this.log.debug('You reached the end of the line.');
      this.activeElBeforeOpen.focus();
    }

    if (e.key && e.key.toLowerCase() === 'esc' && (this.el === document.activeElement || this.el.contains(document.activeElement))) {
      e.preventDefault();
      this.log.debug('Escaping to the element ');
      this.activeElBeforeOpen.focus();
    }
  }

  focusElement(el) {
    el.focus();
  }

  removeListeners() {
    this.log.debug('Remove Keyboard Events from ', this.type, 'with id:', this.keyListenerId);
    svs.utils.keylistener.removeKeyboardListener(this.keyListenerId);
  } 


  triggerClick(element) {
    element.dispatchEvent(new Event('mousedown'));
    element.dispatchEvent(new Event('mouseup'));
  }

}

svs.components.dialog.Accessibility = Accessibility;
 })(window);